import * as React from 'react';
import { api, handleApiError } from 'services/api';
import type { ViagemControle } from 'pages/viagens-controle/types';

export const useApproveViagemControle = () => {
  const approveViagemControle = React.useCallback(async (id: number) => {
    try {
      const { data } = await api.post<ViagemControle>(
        `/viagens-controle/${id}/approve`
      );
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    approveViagemControle,
  };
};
